import React from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'

import ScorecardSlider from '@shared/components/scorecardSlider'
import styles from './style.module.scss'

const CustomLink = dynamic(() => import('@shared/components/customLink'))

const TeamScorecard = ({ data, teamData }) => {
  return (
    <section className='mb-3 mb-md-4'>
      <div className={`${styles.title} d-flex justify-content-between align-items-center`}>
        <h3 className="widget-title small-head mb-0 d-flex align-items-center justify-content-center justify-content-md-start">
          <span>{'Matches'}</span>
        </h3>
        <CustomLink href={`/${teamData?.oSeo?.sSlug}/match`} prefetch={false}>
          <a className="theme-text font-bold">{'View All'}</a>
        </CustomLink>
      </div>
      <div className={styles.seriesScorecard}>
        <ScorecardSlider data={data} />
      </div>
    </section>
  )
}

TeamScorecard.propTypes = {
  data: PropTypes.array,
  teamData: PropTypes.object
}

export default TeamScorecard
